import {errorToast, successToast} from "../../utils/Toasts";
import {AuthHelper} from "../../helpers/AuthHelper";
import {ObjectsHelper} from "../../helpers/ObjectsHelper";
import {getSid} from "./AuthReducer";
import {getObjectTariffs} from "./ObjectReducer";
import {PaymentApi} from "../../api/PaymentApi";
import { ApiErrorHandler } from '../../api/ApiErrorHandler';

const SET_PAYMENT = "SET_PAYMENT"
const SET_BANK_ACCOUNT_MESSAGE = "SET_BANK_ACCOUNT_MESSAGE"

let initialState = {
    payment: null,
    bank_account: null
}

const PaymentReducer = (state = initialState, action) => {
    switch (action.type) {

        case SET_PAYMENT: {
            return {
                ...state,
                payment: action.payment
            }
        }

        case SET_BANK_ACCOUNT_MESSAGE: {
            return {
                ...state,
                bank_account: action.bank_account
            }
        }

        default:
            return state
    }
}

//****ACTION CREATOR****//

export const setPaymentPage = (payment) => ({
    type: SET_PAYMENT, payment
})

export const setBankAccountMessage = (bank_account) => ({
    type: SET_BANK_ACCOUNT_MESSAGE, bank_account
})

//thunk

export const setBankAccountMessageThunk = (message) => {
    return (
        (dispatch) => {
            dispatch(setBankAccountMessage(message))
        }
    )
}

export const postPayment = (params) => {
    let param = params
    let paymentMethod = params.get("payment_method")

    return (
        (dispatch) => {
            PaymentApi.payment_create(param)
                .then(data => {
                    if (data.status === 'ok') {
                        if (paymentMethod === "bank_account") {
                            successToast("Ожидайте получение счета на Email в течении нескольких минут") 
                            dispatch(setBankAccountMessage("Ожидайте получение счета в течении нескольких минут на вашу электронную почту"))
                        } else {
                            dispatch(setPaymentPage(data.data));
                            window.open(data.data.confirmation_url, '_self');
                        }
                        dispatch(getObjectTariffs(AuthHelper.getSid(), ObjectsHelper.getObjectId()))
                    } else {
                        if (data.errors[0].name === "WrongSIDException") {
                            params.delete('sid')
                            let promiseGetSid = dispatch(getSid())
                            Promise.all([promiseGetSid]).then(() => {
                                param.append('sid', AuthHelper.getSid());
                                dispatch(postPayment(param))
                            })
                        }

                        if (data.errors[0].name === "PermissionDenied") {
                            errorToast(data.errors[0].msg)
                        }

                        if (data.errors[0].name === "AbstractException") {
                            errorToast(data.errors[0].msg)
                            return
                        }

                        if (data.errors[0].name === "SystemError") {
                            errorToast("Неизвестная ошибка")
                            return
                        }
                    }
                })
				.catch(e => ApiErrorHandler(e))
        }
    )
}

export default PaymentReducer
